import { Controller } from '@hotwired/stimulus'

import { createApp, type App as VueApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from '@/v2/pipeline6/queryClient'
import { loadGridState } from '@/v2/pipeline6/persister'

export default class extends Controller<HTMLElement> {
  private app?: VueApp
  static values = { requisitionId: Number, editable: Boolean }

  declare requisitionIdValue: number
  declare editableValue: boolean

  async connect (): Promise<void> {
    const [{ default: App }, state] = await Promise.all([
      import('@/v2/pipeline6/App.vue'),
      loadGridState(),
    ])
    if (!this.element.isConnected) return

    this.app = createApp(App, {
      requisitionId: this.requisitionIdValue,
      state: state ?? {},
      editable: this.editableValue
    })

    this.app.use(createPinia())
    this.app.use(VueQueryPlugin, { queryClient })
    this.app.mount(this.element)
  }

  disconnect (): void {
    this.app?.unmount()
  }
}
